import axios from 'axios';
import { useCallback, useState } from 'react';

export default function useComments() {
  const [ratings, setRatings] = useState(0);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [pages, setPages] = useState(0);
  const [comments, setComments] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const getComments = useCallback(async (productId: number, page?: number) => {
    if (!page || page === 1) {
      setLoading(true);
    }
    const response = await axios.get(
      `/api/v1/ratings?product_id=${productId}&page=${page ? page : 1}&limit=6`
    );
    setTotal(response.data.pagination.total);
    setPage(response.data.pagination.page);
    setPages(response.data.pagination.pages);
    setRatings(response.data.ratings);
    if (response?.data?.results?.length > 0) {
      setComments((oldComments: any) => [
        ...oldComments,
        ...response.data.results,
      ]);
    }
    setLoading(false);
  }, []);

  const deleteCommentImage = useCallback(async (imageId: number) => {
    setLoading(true);
    const response = await axios.delete(`/api/v1/ratings/image/${imageId}`);
    setLoading(false);
    return response;
  }, []);

  return {
    comments,
    getComments,
    deleteCommentImage,
    commentsLoading: loading,
    ratings,
    total,
    page,
    pages,
  };
}
